import React from "react";
import styles from "./ServiceCard.module.css";

interface ServiceCardProps {
    image: string;
    agentAvatar: string;
    agentName: string;
    title: string;
    rating: number;
    reviewCount: number;
    location: string;
    price: number;
    status?: "Available" | "Busy";
    showBookmark?: boolean;
}
function ServiceCard({ image, agentAvatar, agentName, title, rating, reviewCount, location, price, status, showBookmark }: ServiceCardProps) {
    return (
        <div className={styles.card}>
            {/* <div className={styles.imageWrap}>
                <img src={image} alt={title} />
            </div> */}
            <div className={styles.imageWrap}>
                <img src={image} alt={title} />

                {/* Only render the overlay container if status or bookmark is requested */}
                {(status || showBookmark) && (
                    <div className={styles.overlayContainer}>
                        {status ? (
                            <span className={`${styles.statusPill} ${status === 'Available' ? styles.statusAvailable : styles.statusBusy}`}>
                                {status}
                            </span>
                        ) : <div />} {/* Empty div keeps the flex layout balanced if only a bookmark is shown */}

                        {showBookmark && (
                            <button className={styles.bookmarkBtn} onClick={(e) => {
                                e.stopPropagation(); // Prevents clicking the card if you just wanted to bookmark
                                console.log("Bookmarked!");
                            }}>
                                {/* Inline SVG for the bookmark icon so you don't need a file */}
                                <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 2C1 1.44772 1.44772 1 2 1H12C12.5523 1 13 1.44772 13 2V14.5L7 11.5L1 14.5V2Z" stroke="#4B5563" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                        )}
                    </div>
                )}
            </div>

            {/* Agent Info */}
            <div className={styles.agentRow}>
                <img src={agentAvatar} alt={agentName} className={styles.avatar} />
                <span className={styles.agentName}>{agentName}</span>
            </div>

            {/* Title */}
            <h3 className={styles.title}>{title}</h3>

            {/* Rating */}
            <div className={styles.ratingRow}>
                <span className={styles.stars}>★★★★★</span>
                <span className={styles.rating}>{rating}</span>
                <span className={styles.reviews}>({reviewCount})</span>
            </div>

            {/* Footer */}
            <div className={styles.footer}>
                <span className={styles.location}>{location}</span>
                <div className={styles.priceContainer}>
                    <p>From</p>
                    <span className={styles.price}>₦ {price.toLocaleString()}</span>
                </div>
            </div>
        </div>
    );
}

export default ServiceCard